import React, { Component, Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { api } from "../../../api/api";
import PageTitle from "../../../Layout/AppMain/PageTitle";
import { Row, Col } from "reactstrap";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import axios from "axios";
import DashboardTiles from "./DashboardTiles";

class Telco extends Component {
  constructor(props) {
    super(props);
    this.state = {
      externalDashboardData: [],
      token: "",
    };
  }

  componentDidMount = () => {
    this.getDashboards();
    this.functionCall();
  };

  functionCall = () => {
    let localAuthorization = localStorage.getItem("onevubasicauthtoken");

    localAuthorization = localAuthorization.substring(6);

    axios
      .post(
        "https://neoautomata.tatacommunications-ts.com/t2ruatapi/powerbi/token",
        {},
        {
          headers: {
            Authorization: localAuthorization,
          },
        }
      )
      .then((response) => {
        this.setState({
          token: response.data.access_token,
        });
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
        }
      });
  };

  getDashboards = () => {
    let dashboardsUrl =
      "referencedata/bytype/neosuites.external.telcodashboards.iframe";
    api
      .get(dashboardsUrl)
      .then((dashboardsResult) => {
        if (dashboardsResult.data !== "undefined") {
          this.setState({
            externalDashboardData: dashboardsResult.data,
          });
        } else {
          this.setState({
            externalDashboardData: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          externalDashboardData: [],
        });
      });
  };

  render() {
    return (
      <Fragment>
        {/* <div>
                        {
                            this.state.externalDashboardData.map((eachObj) => {
                                return (
                                    <div className='mb-3'>
                                        <PowerBIEmbed
                                            embedConfig={{
                                                type: "report",
                                                id: new URLSearchParams(eachObj.referenceValue).get('reportId'),   //  Chagne dymaic value from backend                                  
                                                embedUrl: eachObj.referenceValue,
                                                accessToken: this.state.token,
                                                tokenType: models.TokenType.Aad, 
                                                settings: {
                                                    panes: {
                                                        filters: {
                                                            expanded: true,
                                                            visible: false,
                                                        },
                                                    },
                                                },
                                            }}
                                            eventHandlers={
                                                new Map([
                                                    [
                                                        "loaded",
                                                        function () {
                                                            console.log("Report loaded");
                                                        },
                                                    ],
                                                    [
                                                        "rendered",
                                                        function () {
                                                            console.log("Report rendered");
                                                        },
                                                    ],
                                                    [
                                                        "error",
                                                        function (event) {
                                                            console.log(event.detail);
                                                        },
                                                    ],
                                                ])
                                            }
                                            cssClassName={"Embed-container"}
                                            getEmbeddedComponent={(embeddedReport) => {
                                                window.report = embeddedReport;
                                            }} />
                                    </div>
                                )
                            })
                        }
                    </div> */}

        <div>
          {this.state.externalDashboardData.map((eachObj) => {
            if (eachObj.referenceValue.includes("iframe")) {
              return (
                <div className="row mb-3">
                  <div
                    dangerouslySetInnerHTML={{ __html: eachObj.referenceValue }}
                  />
                </div>
              );
            } else {
              return (
                <div className="mb-3">
                  <PowerBIEmbed
                    embedConfig={{
                      type: "report",
                      id: new URLSearchParams(eachObj.referenceValue).get(
                        "reportId"
                      ), // Change dynamic value from backend
                      embedUrl: eachObj.referenceValue,
                      accessToken: this.state.token,
                      tokenType: models.TokenType.Aad,
                      settings: {
                        panes: {
                          filters: {
                            expanded: true,
                            visible: false,
                          },
                        },
                      },
                    }}
                    eventHandlers={
                      new Map([
                        [
                          "loaded",
                          function () {
                            console.log("Report loaded");
                          },
                        ],
                        [
                          "rendered",
                          function () {
                            console.log("Report rendered");
                          },
                        ],
                        [
                          "error",
                          function (event) {
                            console.log(event.detail);
                          },
                        ],
                      ])
                    }
                    cssClassName={"Embed-container"}
                    getEmbeddedComponent={(embeddedReport) => {
                      window.report = embeddedReport;
                    }}
                  />
                </div>
              );
            }
          })}
        </div>
      </Fragment>
    );
  }
}

export default Telco;
